<template>
    <v-container v-if="data !== undefined">
        <v-card>
            <v-card-title>
                <div style="width: 50%;">
                {{ data.name }}
                </div>
                <div style="width: 50%;" class="text-right">
                    <v-btn fab small color="primary" :href="'/statics/team/' + data.id"><v-icon>bar_chart</v-icon></v-btn>
                </div>
            </v-card-title>

            <v-card-text style="background-color: #F4F6F6;" py-5 mb-5>

                <v-row v-for="(user_row, urid) in user_rows" :key="urid">
                    <v-col v-for="(user, uid) in user_row" :key="uid" cols="4" md="4">
                        <user-card :user="user" :team_user_action="team_user_action" :key="urid+''+uid"></user-card>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" md="12">
                        <br>
                    </v-col>
                </v-row>

                <v-row style="padding-bottom: 15px;">
                    <v-col cols="4" md="4">
                        <h2>{{ trans('team_users.cards.compilations') }}</h2><br>
                        <v-card
                            class="mx-auto"
                            outlined
                        >
                            <v-list-item three-line>
                                <v-list-item-content>

                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <v-list-item-subtitle>
                                                {{ trans('team_users.targets.rating') }}
                                            </v-list-item-subtitle>
                                            <v-progress-linear
                                            style="border-radius: 8px;"
                                            :value="stat_perc.targets.evaluated.perc"
                                            :color="stat_perc.targets.evaluated.color"
                                            height="40"
                                            >
                                            {{ stat_perc.targets.evaluated.perc }} %
                                            </v-progress-linear>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <v-list-item-subtitle>
                                                {{ trans('team_users.targets.approval') }}
                                            </v-list-item-subtitle>
                                            <v-progress-linear
                                            style="border-radius: 8px;"
                                            :value="stat_perc.targets.approved.perc"
                                            :color="stat_perc.targets.approved.color"
                                            height="40"
                                            >
                                            {{ stat_perc.targets.approved.perc }} %
                                            </v-progress-linear>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>

                        </v-card>
                    </v-col>

                    <v-col cols="4" md="4">
                        <h2>{{ trans('team_users.cards.targets') }}</h2><br>
                        <v-card
                            class="mx-auto"
                            outlined
                        >
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <v-list-item-subtitle>
                                                {{ trans('team_users.targets.ended') }}
                                            </v-list-item-subtitle>
                                            <v-progress-linear
                                            style="border-radius: 8px;"
                                            :value="stat_perc.targets.ended.perc"
                                            :color="stat_perc.targets.ended.color"
                                            height="40"
                                            >
                                            {{ stat_perc.targets.ended.perc }} %
                                            </v-progress-linear>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-card>
                    </v-col>

                    <v-col cols="4" md="4">
                        <h2>{{ trans('team_users.cards.activities') }}</h2><br>
                        <v-card
                            class="mx-auto"
                            outlined
                        >
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <v-list-item-subtitle>
                                                {{ trans('team_users.activities.ended') }}
                                            </v-list-item-subtitle>
                                            <v-progress-linear
                                            style="border-radius: 8px;"
                                            :value="stat_perc.activities.ended.perc"
                                            :color="stat_perc.activities.ended.color"
                                            height="40"
                                            >
                                            {{ stat_perc.activities.ended.perc }} %
                                            </v-progress-linear>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>



  </template>
<script>

import UserCard from './UserCard.vue';


export default {

    name: "team-users",

    props: {
        team: { type: Object },
        team_stat: {type: Object },
        team_user_action: { default: '' }


    },
    data() {

        let data = this.team;

        let tot_targets = this.team_stat.targets.tot;
        let tot_set_evaluated = this.team_stat.targets.tot_set_evaluated;

        let target_evaluated_perc = this.perc(tot_set_evaluated, this.team_stat.targets.evaluated);
        let target_evaluated_color = this.percCustomColor(target_evaluated_perc);

        let target_approved_perc = this.perc(tot_targets, this.team_stat.targets.approved);
        let target_approved_color = this.percCustomColor(target_approved_perc);
        let target_ended_perc = this.perc(tot_targets, this.team_stat.targets.ended);
        let target_ended_color = this.percCustomColor(target_ended_perc);

        let activities_ended_perc = this.perc(this.team_stat.activities.tot, this.team_stat.activities.ended);
        let activities_ended_color = this.percCustomColor(activities_ended_perc);

        let stat_perc = {
            targets: {
                evaluated: {
                    perc: target_evaluated_perc,
                    color: target_evaluated_color
                },
                approved: {
                    perc: target_approved_perc,
                    color: target_approved_color
                },

                ended: {
                    perc: target_ended_perc,
                    color: target_ended_color
                }
            },
            activities: {
                ended: {
                    perc: activities_ended_perc,
                    color: activities_ended_color
                }
            }
        }




        let user_rows = [];


        if(data !== undefined) {

            let count_rows = 0;

            let count_columns = 0;

            for(let user of data.users) {


                count_columns++;
                if(user_rows[count_rows] === undefined) {
                    user_rows[count_rows] = [];
                }

                user_rows[count_rows].push(user);

                if(count_columns == 3) {
                    count_rows++;
                    count_columns = 0;
                }


            }




        }



        return {
            data,
            user_rows,
            stat_perc,
        }
    },

    mounted() {
    },
    methods: {



        perc(max, current) {
            let kx = parseFloat(max) == 0.0 ? 0 : 100.0 / parseFloat(max);
            let y = parseFloat(current) * kx;
            return Math.round(y * 100.0) / 100.0;

        },

        percCustomColor(perc) {


                    // default green
                    let color = '#4CAF50'; // 100%
                    let background_color = '#A5D6A7';

                    if(perc < 25.0) {
                        // red
                        color = '#F44336';
                        background_color = '#EF9A9A';

                    } else if(perc <= 50.0) {
                        // orange
                        color = '#FFB74D'; // orange lighten-2
                        background_color = '#FFE0B2'; // orange lighten-4


                    } else if(perc < 75.0) {
                        // orange
                        color = '#FF9800';
                        background_color = '#FFE0B2';


                    } else if(perc > 105) {

                        background_color = '#EF9A9A';

                        if(perc < 110) {
                            // lime darken-4
                            color = '#827717';

                        } else if(perc < 125) {
                            // deep-orange darken-4
                            color = '#BF360C';

                        } else if(perc < 150) {
                            // red accent-4
                            color = '#D50000';

                        } else if(perc < 175) {
                            // pink accent-4
                            color = '#C51162';

                        } else if(perc > 175) {
                            // purple accent-4
                            color = '#AA00FF';
                        }

                    }

                    return color;
        },
    },

    components: {
        UserCard,
    },

    computed: {



    }
}

</script>
